export const VEHICLE_DATA_SOURCE_FB = 1
